import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import Swal from 'sweetalert2';
import {HandleErrorService} from './handle-error.service';
import {ApiService} from '../core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(
    private serviceApi: ApiService,
    private handleError: HandleErrorService
  ) {
  }

  getBlogs(): Observable<any> {
    return this.serviceApi.get(`Configuration/ConfigurationBlog`)
      .pipe(
        catchError(this.handleError.catchHttpError)
      );
  }

  deleteTypeBlog(id): Observable<any> {
    return this.serviceApi.delete(`/Blog/ByIdTypeBlog/${id}`)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  deleteBlog(id, typeId): Observable<any> {
    return this.serviceApi.delete(`Blog/ByIdBlog/${id}/${typeId}`)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            });
          }
        })
      );
  }

  createBlog(body): Observable<any> {
    return this.serviceApi.post(`Blog/Blog`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  createTypeBlog(body): Observable<any> {
    return this.serviceApi.post(`Blog/BlogType`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  editBlog(body): Observable<any> {
    return this.serviceApi.put(`Blog/UBlog`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  editBlogType(body): Observable<any> {
    return this.serviceApi.put(`Blog/UBlogType`, body)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  changeBlogStatus(id, typeId): Observable<any> {
    return this.serviceApi.patch(`Blog/StatuBlog/${id}/${typeId}`, null)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }

  changeBlogTypeStatus(id): Observable<any> {
    return this.serviceApi.patch(`Blog/StatuTypeBlog/${id}`, null)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message
            });
          }
        })
      );
  }
}
